export default function AboutUs() {
  
  return (
    <>
      <div className="main">
        <div className='page-head'>
          <div className="container text-center">
            <nav>
              <ol className="breadcrumb mb-2 justify-content-center">
                <li className="breadcrumb-item"><a href="/">Home</a></li>
                <li className="breadcrumb-item active" aria-current="page">About Us</li>
              </ol>
            </nav>
            <h1>About Us</h1>
          </div>
        </div>
        <section className='section'>
          <div className="container">
            <div className="row">
              <div className="col-lg-5">
                <img src ="assets/images/about.jpg" className='img-width-100' />
              </div>
              <div className="col-lg-1"></div>
              <div className="col-lg-6">
                <p>The Name “OMICRON” stands for more than four decades of experience in the design, development and production of precision cylindrical and centerless grinding machines. “Perfection through innovation” is our passion, highest precision is our aim and top-class quality is our benchmark.</p>
                <p>Our product line includes both standard machines, as well as complex system solution in high precision & high productive cylindrical & centerless grinder for machining small and medium sized work pieces. In addition, we offer variety of auto loading and unloadingoption, system integration and in process gauging options, we also offer tailored solution for complex and standard work pieces.</p>
                <p>Our customer includes companies from the machine tool industry, automotive engineering, tool and die makers, the aerospace industries, pneumatic/hydraulics, electronics/electrical engineering, medical technology and job order production. They value maximum precision, safety, productivity, and longevity.</p>
                <div className="saperator"></div>
                <h3 className='main-title'>Why Omicron?</h3>
                <div className='info-list'>
                  <ul>
                    <li>More than 45 years of Experience in precision and production machine design,</li>
                    <li>A very high level of expertise in production grinding,</li>
                    <li>Support for optimum design of the grinding part during the development phase,</li>
                    <li>Pharma machinery</li>
                    <li>Food processing ind</li>
                    <li>Ceramic industries</li>
                    <li>Printing and paper industries</li>
                    <li>Dia & Mold</li>
                    <li>Bearings industries</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <section className='section pt-0'>
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                
              </div>
              <div className="col-lg-6">
              <h3 className='main-title'>Why Omicron?</h3>
                <div className='info-list'>
                  <ul>
                    <li>More than 45 years of Experience in precision and production machine design,</li>
                    <li>A very high level of expertise in production grinding,</li>
                    <li>Support for optimum design of the grinding part during the development phase,</li>
                    <li>Pharma machinery</li>
                    <li>Food processing ind</li>
                    <li>Ceramic industries</li>
                    <li>Printing and paper industries</li>
                    <li>Dia & Mold</li>
                    <li>Bearings industries</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section> */}
      </div>
    </>
  )
}
